import React from 'react';

const MintDBLoader = () => {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 position-relative bg-light text-dark overflow-hidden">

      {/* Molecular Floating Dots */}
      <div className="position-absolute top-0 start-0 w-100 h-100">
        {[
          { top: '10%', left: '10%' },
          { top: '30%', left: '80%' },
          { top: '60%', left: '50%' },
          { top: '70%', left: '20%' },
          { top: '40%', left: '35%' },
          { top: '20%', left: '70%' }
        ].map((pos, i) => (
          <div
            key={i}
            className="position-absolute molecule-dot"
            style={{
              top: pos.top,
              left: pos.left,
              animationDelay: `${i * 0.4}s`
            }}
          />
        ))}
      </div>

      {/* Foreground Content */}
      <div className="text-center position-relative z-3">
        <div
          className="spinner-border mb-4"
          role="status"
          style={{
            width: '5rem',
            height: '5rem',
            borderWidth: '6px',
            borderColor: '#1A2940',
            borderTopColor: 'transparent'
          }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>

        <h1 className="display-4 fw-bold mb-2" style={{ color: '#1A2940' }}>
          MintDB
        </h1>

        <span
          className="badge"
          style={{
            backgroundColor: '#dbe4ef',
            color: '#1A2940',
            border: '1px solid #1A2940'
          }}
        >
          v1.0
        </span>
      </div>

      {/* Custom Styles */}
      <style>{`
        .molecule-dot {
          width: 8px;
          height: 8px;
          background-color: rgba(26, 41, 64, 0.3);
          border-radius: 50%;
          animation: pulseDot 4s ease-in-out infinite, floatDot 5s ease-in-out infinite;
        }

        @keyframes pulseDot {
          0%, 100% {
            transform: scale(1);
            opacity: 0.2;
          }
          50% {
            transform: scale(1.6);
            opacity: 0.7;
          }
        }

        @keyframes floatDot {
          0%, 100% {
            transform: translateY(0);
            opacity: 0.3;
          }
          50% {
            transform: translateY(-0.7rem);
            opacity: 0.9;
          }
        }
      `}</style>
    </div>
  );
};

export default MintDBLoader;
